export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q03_a.356f5529.png";